export const isFindingValid = (finding) => {
    return !finding.invalid;
};
//# sourceMappingURL=utils.js.map